"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _escapeRegExp = _interopRequireDefault(require("../../../utils/escapeRegExp"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var filterFunction = function filterFunction(query) {
  var regexp = new RegExp((0, _escapeRegExp["default"])(query), 'i');
  return function (item) {
    if (typeof item.title === 'string') {
      return regexp.test(item.title) || regexp.test(_l10n["default"].translate(item.title));
    }
  };
};

function _default(query, customFilter) {
  if (typeof customFilter === 'function') {
    return function (item) {
      return customFilter(item, query);
    };
  } else {
    return filterFunction(query);
  }
}